import { FormattedMessage } from 'react-intl';
import { Col, Grid, Modal, Row } from 'rsuite';

import { OpenModal } from '../../../containers/styled/alerts';
import { ViewMarginDiv } from '../../../containers/styled/layout';
import { StyledModalDivider } from '../../../containers/styled/styled';
import {
  H5,
  ViewLabel,
  ViewLabelValue
} from '../../../containers/styled/typography';
import AuditFieldsView from '../../generic/AuditFieldsView';

/**
 * Cross matching View screen
 *
 * Cross matching view to display each cross-matching in-detail.
 *
 * @component
 * @param {object} item              prop used to prepopulate the form fields with data when editing
 * @param {boolean} handleClose      handles modal close event
 * @returns cross-matching view modal.
 *
 */
const CrossMatchingView = ({ item, handleClose }) => (
  <OpenModal
    onClose={handleClose}
    size='md'
    title={
      <FormattedMessage
        id='crossMatching.details.title'
        defaultMessage='Cross Matching Information'
      />
    }
  >
    <Modal.Body style={{ marginBottom: 30 }}>
      <Grid fluid>
        <Row>
          <Col xs={8}>
            <ViewLabel>
              <FormattedMessage
                id='crossMatching.view.label.blood.product'
                defaultMessage='Blood Product'
              />
            </ViewLabel>
            <ViewLabelValue>{item.bloodProduct}</ViewLabelValue>
          </Col>
          <Col xs={8}>
            <ViewLabel>
              <FormattedMessage
                id='crossMatching.view.label.bloodType'
                defaultMessage='Blood Type'
              />
            </ViewLabel>
            <ViewLabelValue>{item.bloodType}</ViewLabelValue>
          </Col>
          <Col xs={8}>
            <ViewLabel>
              <FormattedMessage
                id='crossMatching.view.label.patient.name'
                defaultMessage='Patient Name'
              />
            </ViewLabel>
            <ViewLabelValue>{item.name}</ViewLabelValue>
          </Col>
        </Row>
        <ViewMarginDiv />
        <H5>
          <FormattedMessage
            id='crossMatching.view.details.result'
            defaultMessage='Result'
          />
        </H5>
        <StyledModalDivider />
        <Row>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='crossMatching.view.label.isMatch'
                defaultMessage='Is Match ?'
              />
            </ViewLabel>
            <ViewLabelValue>{item.isMatch}</ViewLabelValue>
          </Col>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='crossMatching.view.label.status'
                defaultMessage='Status'
              />
            </ViewLabel>
            <ViewLabelValue>{item.status}</ViewLabelValue>
          </Col>
        </Row>
        <ViewMarginDiv />
        <H5>
          <FormattedMessage
            id='crossMatching.view.details.healthWorkerInformation'
            defaultMessage='Health Worker Information'
          />
        </H5>
        <StyledModalDivider />
        <Row>
          <Col xs={24}>
            <ViewLabel>
              <FormattedMessage
                id='crossMatching.view.label.healthWorkerName'
                defaultMessage='Name'
              />
            </ViewLabel>
            <ViewLabelValue>{item.healthCareWorkers}</ViewLabelValue>
          </Col>
        </Row>
        <ViewMarginDiv />
        <H5>
          <FormattedMessage
            id='crossMatching.view.details.equipmentConsumables'
            defaultMessage='Equipment & Consumables'
          />
        </H5>
        <StyledModalDivider />
        <Row>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='crossMatching.view.label.equipments'
                defaultMessage='Equipments'
              />
            </ViewLabel>
            {item.equipments !== ''
              ? (
                  item.equipments.map((data, index) => {
                    return <ViewLabelValue style={{ lineHeight: '10px' }} key={index}>{data.name}</ViewLabelValue>;
                  })
                )
              : (
                <ViewLabelValue>
                  <FormattedMessage
                    id='crossMatching.view.label.equipments.notApplicable'
                    defaultMessage='N/A'
                  />
                </ViewLabelValue>
                )}
          </Col>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='crossMatching.view.label.consumables'
                defaultMessage='Consumables'
              />
            </ViewLabel>
            {item.consumables !== ''
              ? (
                  item.consumables.map((data, index) => {
                    return <ViewLabelValue style={{ lineHeight: '10px' }} key={index}>{data.name}</ViewLabelValue>;
                  })
                )
              : (
                <ViewLabelValue>
                  <FormattedMessage
                    id='crossMatching.view.label.consumables.notApplicable'
                    defaultMessage='N/A'
                  />
                </ViewLabelValue>
                )}
          </Col>
        </Row>
        <ViewMarginDiv />
      </Grid>
      <H5>
        <FormattedMessage
          id='crossMatching.view.details.otherInformation'
          defaultMessage='Other Information'
        />
      </H5>
      <StyledModalDivider />
      <AuditFieldsView item={item} />
    </Modal.Body>
  </OpenModal>
);

export default CrossMatchingView;
